import { Element } from "react-scroll";
import React, { Suspense } from "react";
import CompanyBasicSection from 'components/company/companybasicsection';
//import Investorsection from 'components/company/investorsection';
import CompanyAboutSection from 'components/company/companyAboutSection';
import Peersection from 'components/company/peersection';
//import QuarterResultSection from 'components/company/quarterresultsection';
import RatioSection from 'components/company/ratiosection';
import BalancesheetSection from 'components/company/balancesheetsection'; 
import CashFlowSection from 'components/company/cashflowsection';
import ProfitNLossSection from 'components/company/profitNlosssection';
import StockChartSection from 'components/company/stockchartsection';
import Forumsection from 'components/company/forumsection';
//import AnalysisSection from 'components/company/analysissection';
import CompanyNews from '../../pages/news/CompanyNews'
//import CompanyFAQ from 'components/company/company-faq';
import Loaderanimation from 'components/ui/loaderanimation';
import { useCompanyFin } from "contexts/companyfindata/companyfindata.context.tsx";

const QuarterResultSection = React.lazy(() =>
  import('components/company/quarterresultsection')
);

const AnalysisSection = React.lazy(() =>
  import('components/company/analysissection')
);
const Investorsection = React.lazy(() =>
  import('components/company/investorsection')
);
const CompanyFAQ = React.lazy(() =>
  import('components/company/company-faq')
);

export default function CompanySections({companysectionlist,companyinfo,type,companymainLabelsList,isFollowed}) {
  console.log("company basic data ",companyinfo);
  const { compratiodefault , compratiodefloading } = useCompanyFin();
  console.log("compratiodefault data ",compratiodefault);
const isDataEmpty =
  !compratiodefloading &&
  Object.keys(compratiodefault || {}).length === 0;

if (isDataEmpty) {
  return (
    <div className="space-y-10 px-0 md:p-8">
      <Element name="section1" id="section1">
        <CompanyBasicSection
          companyinfo={companyinfo}
          companymainLabelsList={companymainLabelsList}
          isFollowed={isFollowed}
        />
      </Element>
       <section className="w-full bg-white rounded-2xl shadow-md border border-gray-100 p-10 text-center">
      <div className="flex justify-center mb-4">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 text-3xl">
          ⚠️
        </div>
      </div>
      <h3 className="text-xl font-semibold text-gray-800">
        Data Not Available
      </h3>
      <p className="mt-3 text-sm text-gray-600 max-w-md mx-auto">
        Our team is working to update this information. Please check back later.
      </p>
    </section>
    </div>
  );
}

return (
  <div className="space-y-10 px-0 md:p-8">
    
    {companysectionlist
      .filter((val) => {
        if (isDataEmpty) {
          return val.id === "section1";
        }
        return true;
      })
      .map((val) => (
        <Element key={val.id} name={val.id} id={val.id}>
          {val.id === "section1" ? (
            <CompanyBasicSection
              companyinfo={companyinfo}
              companymainLabelsList={companymainLabelsList}
              isFollowed={isFollowed}
            />
          )
          : val.id === "section3" ? (
            <Suspense fallback={<Loaderanimation count={10} />}>
              <AnalysisSection companyinfo={companyinfo} />
            </Suspense>
          ) 
          : val.id === "section2" ? (
        <StockChartSection companyinfo={companyinfo} />
      ) 
      
      : val.id === "section10" ? (
         <Suspense fallback={<Loaderanimation count={10} />}>
          <Investorsection companyinfo={companyinfo} />
         </Suspense>
      ) : 
       val.id === "section4" ? (
        <Peersection companyinfo={companyinfo} />
      ) 
      : 
       val.id === "section5" ? (
        <Suspense fallback={<Loaderanimation  count={10}/>}>
        <QuarterResultSection companyinfo={companyinfo} type={type} />
        </Suspense>
      ) 
      : 
       val.id === "section7" ? (
        <BalancesheetSection companyinfo={companyinfo} type={type} />
      ) 
       :
       val.id === "section6" ? (
        <ProfitNLossSection companyinfo={companyinfo} type={type} />
      ) 
       :
       val.id === "section8" ? (
        <CashFlowSection companyinfo={companyinfo} type={type} />
      ) 
       : 
       val.id === "section9" ? (
        <RatioSection companyinfo={companyinfo} type={type} />
      ) 
       : 
       val.id === "section11" ? (
        <Forumsection companyinfo={companyinfo} />     
      ) 
      :
      val.id === "section13" ? (
        <CompanyNews tag={companyinfo.symbol} />     
      )
      : 
       (<section className="bg-white shadow-md z-50 rounded-xl p-5">
          <h1 className="text-3xl font-bold">{val.label}</h1>
          <p className="mt-4">Check back soon.</p>
        </section>
      )}
        </Element>
      ))}

     {/*isDataEmpty && (
      <section className="w-full bg-white rounded-2xl shadow-md border border-gray-100 p-10 text-center">
      <div className="flex justify-center mb-4">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 text-3xl">
          ⚠️
        </div>
      </div>
      <h3 className="text-xl font-semibold text-gray-800">
        Data Not Available
      </h3>
      <p className="mt-3 text-sm text-gray-600 max-w-md mx-auto">
        Our team is working to update this information. Please check back later.
      </p>
    </section>
    )*/}
    {!isDataEmpty && (
      <Suspense fallback={<Loaderanimation count={10} />}>
        <CompanyFAQ companyinfo={companyinfo} type={type} />
      </Suspense>
    )}
  </div>
);
}
